exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-wrap[data-v-6a742ea5] {\n  --mdc-theme-on-primary: white;\n  margin: 12px 0 32px;\n}\n.form-action[data-v-6a742ea5] {\n  height: 32px;\n  margin: 0 8px 0 0;\n  text-transform: capitalize;\n}\n", ""]);

// exports
